var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSummeryerrors(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 248.273,
    height: 248,
    viewBox: "0 0 248.273 248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_12428194_4982758",
    "data-name": "12428194_4982758",
    transform: "translate(0.344 0.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND",
    transform: "translate(-0.344 -0.344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5186",
    "data-name": "Group 5186",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3238",
    "data-name": "Rectangle 3238",
    width: 248,
    height: 248,
    transform: "translate(0.273 0.274)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_871",
    "data-name": "Ellipse 871",
    cx: 8.097,
    cy: 8.097,
    rx: 8.097,
    ry: 8.097,
    transform: "translate(58.148 28.77)",
    fill: "#2f3a79",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_872",
    "data-name": "Ellipse 872",
    cx: 5.434,
    cy: 5.434,
    rx: 5.434,
    ry: 5.434,
    transform: "translate(141.283 172.827)",
    fill: "#2f3a79",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_873",
    "data-name": "Ellipse 873",
    cx: 11.332,
    cy: 11.332,
    rx: 11.332,
    ry: 11.332,
    transform: "translate(84.924 155.837)",
    fill: "#7b4a4a",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_874",
    "data-name": "Ellipse 874",
    cx: 7.518,
    cy: 7.518,
    rx: 7.518,
    ry: 7.518,
    transform: "translate(198.678 50.197)",
    fill: "#7b4a4a",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_875",
    "data-name": "Ellipse 875",
    cx: 6.873,
    cy: 6.873,
    rx: 6.873,
    ry: 6.873,
    transform: "translate(185.038 155.636)",
    fill: "#7b4a4a",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_877",
    "data-name": "Ellipse 877",
    cx: 5.059,
    cy: 5.059,
    rx: 5.059,
    ry: 5.059,
    transform: "translate(26.308 53.07)",
    fill: "#7b4a4a",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_878",
    "data-name": "Ellipse 878",
    cx: 7.901,
    cy: 7.901,
    rx: 7.901,
    ry: 7.901,
    transform: "translate(-0.344 116.933)",
    fill: "#fcfbac",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_879",
    "data-name": "Ellipse 879",
    cx: 7.441,
    cy: 7.441,
    rx: 7.441,
    ry: 7.441,
    transform: "translate(226.621 116.59)",
    fill: "#fcfbac",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_880",
    "data-name": "Ellipse 880",
    cx: 5.536,
    cy: 5.536,
    rx: 5.536,
    ry: 5.536,
    transform: "translate(28.16 87.444)",
    fill: "#ff8080",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_881",
    "data-name": "Ellipse 881",
    cx: 4.747,
    cy: 4.747,
    rx: 4.747,
    ry: 4.747,
    transform: "translate(183.754 21.138)",
    fill: "#ff8080",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_882",
    "data-name": "Ellipse 882",
    cx: 7.266,
    cy: 7.266,
    rx: 7.266,
    ry: 7.266,
    transform: "translate(118.736 28.655)",
    fill: "#333",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS",
    transform: "translate(19.797 17.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5188",
    "data-name": "Group 5188",
    transform: "translate(1.991 14.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16181",
    "data-name": "Path 16181",
    d: "M177.106,98.058c13.052,33.217,79.721,23.068,66.138,104.362-7.412,44.363-157.921,61.026-186.837,16.472-24.7-38.054-8.561-86.266,16.846-121.906C112.453,42,163.433,63.259,177.106,98.058Z",
    transform: "translate(-44.127 -63.345)",
    fill: "#ff74bd",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5187",
    "data-name": "Group 5187",
    transform: "translate(5.611 87.039)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_886",
    "data-name": "Ellipse 886",
    cx: 6.139,
    cy: 4.018,
    rx: 6.139,
    ry: 4.018,
    transform: "translate(1.816 11.612) rotate(-71.041)",
    fill: "#fcfffd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16182",
    "data-name": "Path 16182",
    d: "M63.77,293.7c-3.86.446-7.542-3.973-8.224-9.87s1.895-11.04,5.755-11.486,4.823,4.159,5.5,10.056S67.63,293.25,63.77,293.7Z",
    transform: "translate(-55.437 -255.673)",
    fill: "#fcfffd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_887",
    "data-name": "Ellipse 887",
    cx: 2.258,
    cy: 2.258,
    r: 2.258,
    transform: "translate(8.528 41.138)",
    fill: "#fcfffd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5197",
    "data-name": "Group 5197",
    transform: "translate(124.02 55.784)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_888",
    "data-name": "Ellipse 888",
    cx: 36.704,
    cy: 5.849,
    rx: 36.704,
    ry: 5.849,
    transform: "translate(9.626 135.985)",
    fill: "#404c73",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5235",
    "data-name": "Group 5235",
    transform: "translate(29.056 9.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5189",
    "data-name": "Group 5189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16183",
    "data-name": "Path 16183",
    d: "M364.964,175.545c.9-3.782-1.343-5.385-2.39-5.768a3.777,3.777,0,0,0-2.189-3.334c-2.588-1.244-7.863-1.443-10.6.846-2.08,1.741-1.078,6,1.139,6.421,2.123.4,8.945,5.078,9.65,5.987A5.313,5.313,0,0,0,364.964,175.545Z",
    transform: "translate(-348.647 -165.529)",
    fill: "#404c73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16184",
    "data-name": "Path 16184",
    d: "M361.549,179.47a3.867,3.867,0,0,1-.216-5.948c-4.806,2.52-10.086,2.016-12.341-2.261-.9,2,.1,4.986,1.939,5.335,2.123.4,8.945,5.078,9.65,5.987a5.312,5.312,0,0,0,4.388-4.152,7.914,7.914,0,0,0,.146-.815C364.341,179.09,363.154,180.113,361.549,179.47Z",
    transform: "translate(-348.653 -168.417)",
    fill: "#262743"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_889",
    "data-name": "Ellipse 889",
    cx: 2.593,
    cy: 0.886,
    rx: 2.593,
    ry: 0.886,
    transform: "translate(5.056 0.737)",
    fill: "#fcfffd",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_890",
    "data-name": "Ellipse 890",
    cx: 1.124,
    cy: 0.886,
    rx: 1.124,
    ry: 0.886,
    transform: "translate(12.818 5.459)",
    fill: "#fcfffd",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16185",
    "data-name": "Path 16185",
    d: "M352.28,178.658s-1.24,7.364-.224,9.777,2.35,2.223,2.35,2.223v2.54s-2.937.64-3.212,2.438c-.342,2.237-1.06,6.272,3.71,7.6s6.647-2.563,7.808-4.517-1.7-4.82-1.7-4.82a21.959,21.959,0,0,1-.572-6.287,2.2,2.2,0,0,0,2.274-2.332c0-2.263-1.645-1.691-1.72-1.093a4,4,0,0,1-.336-1.643,5.608,5.608,0,0,0-1-3.247A6.81,6.81,0,0,1,352.28,178.658Z",
    transform: "translate(-349.804 -172.145)",
    fill: "#ffcbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16186",
    "data-name": "Path 16186",
    d: "M361.312,185.48c.324.105.469-1,.842-1.319a4.05,4.05,0,0,1-.325-1.62,5.609,5.609,0,0,0-1-3.247,6.809,6.809,0,0,1-7.374-.636s-.08.478-.183,1.227c3.031,1.867,6.457.7,7.056.964S360.942,185.48,361.312,185.48Z",
    transform: "translate(-350.977 -172.145)",
    fill: "#ffad81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16187",
    "data-name": "Path 16187",
    d: "M364.17,201.466a18.357,18.357,0,0,1-.245-4.076,7.376,7.376,0,0,1-6,2.706v2.531C360.018,203.353,362.256,202.5,364.17,201.466Z",
    transform: "translate(-353.321 -181.583)",
    fill: "#ffad81"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5195",
    "data-name": "Group 5195",
    transform: "translate(2.106 8.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5191",
    "data-name": "Group 5191",
    transform: "translate(0.311 1.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5190",
    "data-name": "Group 5190",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_891",
    "data-name": "Ellipse 891",
    cx: 0.668,
    cy: 0.527,
    rx: 0.668,
    ry: 0.527,
    transform: "translate(4.114 1.834) rotate(-83.875)",
    fill: "#262743"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_892",
    "data-name": "Ellipse 892",
    cx: 0.668,
    cy: 0.527,
    rx: 0.668,
    ry: 0.527,
    transform: "translate(0 1.329) rotate(-83.875)",
    fill: "#262743"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5192",
    "data-name": "Group 5192",
    transform: "translate(1.871 2.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16188",
    "data-name": "Path 16188",
    d: "M357.354,189.952a.808.808,0,0,0,.227-.046.083.083,0,0,0-.055-.157.593.593,0,0,1-.581-.093.312.312,0,0,1-.108-.306,2.22,2.22,0,0,1,.318-.536c.282-.4.6-.863.511-1.218a.084.084,0,0,0-.1-.06.082.082,0,0,0-.06.1c.072.28-.238.724-.487,1.081a2.171,2.171,0,0,0-.344.595.472.472,0,0,0,.16.467A.725.725,0,0,0,357.354,189.952Z",
    transform: "translate(-356.662 -187.535)",
    fill: "#ff6162"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5193",
    "data-name": "Group 5193",
    transform: "translate(4.246 0.572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16189",
    "data-name": "Path 16189",
    d: "M361.478,184.167a.244.244,0,0,1,.146-.119,2.406,2.406,0,0,1,2.381.714.246.246,0,0,1-.331.364,1.93,1.93,0,0,0-1.907-.608.246.246,0,0,1-.289-.351Z",
    transform: "translate(-361.449 -183.958)",
    fill: "#262743"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16190",
    "data-name": "Path 16190",
    d: "M353.051,183.367c-.194,0-.222-.487-.024-.526a2.3,2.3,0,0,1,1.679.355.264.264,0,0,1-.088.48.241.241,0,0,1-.2-.037A1.77,1.77,0,0,0,353.051,183.367Z",
    transform: "translate(-352.891 -182.805)",
    fill: "#262743"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5194",
    "data-name": "Group 5194",
    transform: "translate(0.669 5.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16191",
    "data-name": "Path 16191",
    d: "M355.861,195.158a3.259,3.259,0,0,0,2-.771.1.1,0,0,0,.043-.126.094.094,0,0,0-.125-.043,3.42,3.42,0,0,1-3.384-.4.093.093,0,0,0-.133,0,.1.1,0,0,0,0,.132A2.475,2.475,0,0,0,355.861,195.158Z",
    transform: "translate(-354.238 -193.791)",
    fill: "#fcfffd"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_893",
    "data-name": "Ellipse 893",
    cx: 0.191,
    cy: 0.321,
    rx: 0.191,
    ry: 0.321,
    transform: "translate(2.158 4.393) rotate(-83.875)",
    fill: "#fcfffd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16192",
    "data-name": "Path 16192",
    d: "M355.749,197.636c-.032.3.373.586.9.643s.988-.138,1.02-.437S355.781,197.337,355.749,197.636Z",
    transform: "translate(-354.33 -190.204)",
    fill: "#ffad81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16193",
    "data-name": "Path 16193",
    d: "M371.583,190.764c-.287-.089-.647.253-.806.763s-.055,1,.232,1.086c.143.045.551-.355.694-.818S371.726,190.808,371.583,190.764Z",
    transform: "translate(-361.865 -186.808)",
    fill: "#ffad81"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5196",
    "data-name": "Group 5196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16194",
    "data-name": "Path 16194",
    d: "M297.1,151.375c-.451-.425-.076-2.773-.339-3.247a3.668,3.668,0,0,0-2.05-1.167.989.989,0,0,0-1.095.571c-.918-1.032-1.949-.117-1.624.645a5.121,5.121,0,0,0-1.433,2.705c-.551.084-.635.976-.21,1.4.562.568,3.1,1.995,4.062,1.971.322-.008,1.924,2.839,1.924,2.839.96-1.038,2.188-2.045,3.185-3.054C299.523,154.042,297.259,151.521,297.1,151.375Z",
    transform: "translate(-290.084 -146.958)",
    fill: "#ffcbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16195",
    "data-name": "Path 16195",
    d: "M295.7,150.271c-1.381.46-1.4,2.636-3.232,2.1-.057-.82.957-2.05,1.089-3.212-.709.842-1.662,3.748-2.1,3.9a1.29,1.29,0,0,1-1.367-.267.983.983,0,0,0,.263.6c.562.568,3.1,1.995,4.062,1.971.322-.008,1.924,2.839,1.924,2.839.516-.557,1.107-1.1,1.7-1.649C296.993,154.416,293.3,153.536,295.7,150.271Z",
    transform: "translate(-290.09 -148.069)",
    fill: "#ffad81"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16196",
    "data-name": "Path 16196",
    d: "M436.231,164.473c-.19-.216.277-2.344-.126-2.412a8.037,8.037,0,0,0-1.387.03s-.663-.983-1.19-1.018a8.4,8.4,0,0,0-3.225,1.509c-.314.427-.023,2.544-.514,2.9-.2.142-2.525,2.476-5.693,5.629.836.943,1.74,1.843,2.652,2.742,2.888-3.132,5.261-5.576,5.6-5.523.927.143,3.92-.759,4.093-1.522A4.433,4.433,0,0,0,436.231,164.473Z",
    transform: "translate(-357.607 -154.069)",
    fill: "#ffcbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16197",
    "data-name": "Path 16197",
    d: "M436.274,164.339a5.42,5.42,0,0,0-2.014.441c.472.944.944,2.36.472,2.832-1.416.944-1.416-1.888-2.832-1.888.439,2.193-1.977,3.976-4.215,3.459-.96.954-2.193,2.184-3.59,3.575.836.943,1.74,1.843,2.652,2.742,2.888-3.132,5.261-5.576,5.6-5.523.927.143,3.92-.759,4.093-1.522a4.438,4.438,0,0,0-.212-2.336A8.385,8.385,0,0,1,436.274,164.339Z",
    transform: "translate(-357.607 -155.715)",
    fill: "#ffad81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16198",
    "data-name": "Path 16198",
    d: "M395.611,408.044l1.285,6.062-3.141.866-2.413-6.063Z",
    transform: "translate(-341.104 -278.508)",
    fill: "#ffcbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16199",
    "data-name": "Path 16199",
    d: "M349.331,391.05l1.8,5.146-3.1,1.549-2.82-5.642Z",
    transform: "translate(-317.859 -269.946)",
    fill: "#ffcbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16200",
    "data-name": "Path 16200",
    d: "M363.251,346.522l-6.071,2.024s-5.118-21.7-6.129-25.233-7.8-24.72-7.8-24.72-7.658,14.649-7.8,16.456S341.4,338.2,341.4,338.2l-7.953,2.585s-8.876-23.409-8.876-26.156,7.4-30.259,7.4-30.259h23.561s4.626,30.354,5.348,34.835S363.251,346.522,363.251,346.522Z",
    transform: "translate(-307.458 -216.194)",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16201",
    "data-name": "Path 16201",
    d: "M338.729,302.5c.372,1.546-6.8,14.024-7.559,14.934-.636.762-3.514,3.189-4.158,2.336-.3-.4,6.187-21.982,6.7-22.6C334.671,296.006,338.357,300.954,338.729,302.5Z",
    transform: "translate(-308.685 -222.556)",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16202",
    "data-name": "Path 16202",
    d: "M376.413,324.729c-1.2.365-8.216-19.667-8.216-21.81s4.4-4.37,5.741-3.859C378.185,300.677,377.611,324.364,376.413,324.729Z",
    transform: "translate(-329.442 -223.558)",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16203",
    "data-name": "Path 16203",
    d: "M342.393,194.755s-.111,19.188,1.329,25.059c0,0-10.744,5.206-26.917,0a134.163,134.163,0,0,0,1.44-15.065c0-5.538-.111-14.622-.111-14.622s-16.7-27.052-19.69-31.372l3.725-4.6s19.763,22.284,21.438,23.488,4.346,3.171,4.346,3.171l1.353,6.212,5.252-5.477a29.93,29.93,0,0,0,5.359-1.314c4.628-1.58,23.829-17.352,25.978-18.734l3.842,3.485Z",
    transform: "translate(-294.296 -150.585)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16204",
    "data-name": "Path 16204",
    d: "M369.738,167.652l-1.827-1.658c-3.764,3.8-8.668,9.206-12.162,12.551-2.718,2.6-7.592,8.862-13.05,11.343-.992.5-1.361-3.429-2.481-2.977s.505,16.1-3.679,17.9c-3.319,1.424-12.765,3.034-15.742-.439-.992-1.488,1.146-4.556-.342-5.548-2.977-3.473,2.279-12.2,1.283-12.657-1.488-.5-2.142,1.746-3.63.754-3.473-3.473-6.572-9.954-8.068-12s-6.112-9.3-9.992-15.48l-1.6,1.979c2.991,4.32,19.69,31.372,19.69,31.372s.111,9.083.111,14.622a134.177,134.177,0,0,1-1.44,15.065c16.172,5.206,26.917,0,26.917,0-1.44-5.871-1.329-25.059-1.329-25.059Z",
    transform: "translate(-294.297 -153.247)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16205",
    "data-name": "Path 16205",
    d: "M405.122,424.956c.093,1.442-2.345,2.1-5.061.494s-4.8-2.691-5.173-3.185a10.225,10.225,0,0,1-.231-4.5c.292-.66,2.9-1.342,3.755-.661s1.944,2.631,2.746,3.618S405,423.042,405.122,424.956Z",
    transform: "translate(-342.697 -282.931)",
    fill: "#262743"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16206",
    "data-name": "Path 16206",
    d: "M348.7,398.536c-.7-.452-3.255.721-3.7,1.416s-.989,3.721-1.651,4.525-3.937,4.708-2.1,5.383,9.712-6.426,9.882-6.944S349.8,399.245,348.7,398.536Z",
    transform: "translate(-315.583 -273.667)",
    fill: "#262743"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5211",
    "data-name": "Group 5211",
    transform: "translate(0 78.438)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_894",
    "data-name": "Ellipse 894",
    cx: 36.704,
    cy: 5.849,
    rx: 36.704,
    ry: 5.849,
    transform: "translate(0 122.464)",
    fill: "#404c73",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5207",
    "data-name": "Group 5207",
    transform: "translate(3.089 0.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16224",
    "data-name": "Path 16224",
    d: "M63.555,204.326s-6.888-6.162-7.244-6.813a6.034,6.034,0,0,0-1.969-2.14c-.887-.532-3.393-1.037-3.629-.643s2.056,1.034,1.989,1.406-5.8.1-6.136.371-.337,2.054.3,2.426a17.518,17.518,0,0,0,3.113,1.181c.876.236,4.54.63,4.54.63l5.426,6.751Z",
    transform: "translate(-46.342 -194.589)",
    fill: "#ffcbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16225",
    "data-name": "Path 16225",
    d: "M55.151,200.309c-.654,1.419-2.8,1.475-3.927,1.419-1.356-.067-4.879-.451-4.843-2.352-.107.635.015,1.691.491,1.967a17.514,17.514,0,0,0,3.113,1.181c.876.236,4.54.63,4.54.63l5.426,6.751,2.089-1.628C58.423,203.88,56.349,203.9,55.151,200.309Z",
    transform: "translate(-46.343 -197.001)",
    fill: "#ffad81"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5208",
    "data-name": "Group 5208",
    transform: "translate(66.387 3.185)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16226",
    "data-name": "Path 16226",
    d: "M173.922,213.951s1.673-7.937,1.619-8.36a28.509,28.509,0,0,1-1.151-2.992c-.028-.69,2.369-3.509,2.784-3.555s.678.206.607.8c.872-.557,1.722.013,1.593.792.637-.3,1.253.36.85,1.082.841-.192,1,.717.546,1.1.392-.011.651.373.087,1.33a28.008,28.008,0,0,1-1.666,2.358l-.536,8.633Z",
    transform: "translate(-173.922 -199.038)",
    fill: "#ffcbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16227",
    "data-name": "Path 16227",
    d: "M177.634,201.314c-.677.837-1.455,1.461-1.32,1.994.3,1.174,1.974,1.547,1.56,2.738s-1.289,1.091-2.337.816c-.107,1.087-1.614,8.235-1.614,8.235l4.736,1.189.536-8.633a28.127,28.127,0,0,0,1.666-2.358,2.214,2.214,0,0,0,.324-.852C179.635,206.9,176.072,203.945,177.634,201.314Z",
    transform: "translate(-173.922 -200.185)",
    fill: "#ffad81"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5236",
    "data-name": "Group 5236",
    transform: "matrix(0.978, -0.208, 0.208, 0.978, 31.484, 3.436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5189-2",
    "data-name": "Group 5189",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16183-2",
    "data-name": "Path 16183",
    d: "M.207,10.015C-.689,6.234,1.55,4.631,2.6,4.247A3.777,3.777,0,0,1,4.787.913c2.588-1.244,7.863-1.443,10.6.846,2.08,1.741,1.078,6-1.139,6.42-2.123.4-8.946,5.078-9.651,5.987A5.313,5.313,0,0,1,.207,10.015Z",
    fill: "#404c73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16184-2",
    "data-name": "Path 16184",
    d: "M3.567,8.209a3.867,3.867,0,0,0,.216-5.948C8.589,4.782,13.869,4.277,16.124,0c.9,2-.1,4.986-1.939,5.335-2.123.4-8.946,5.078-9.651,5.987A5.312,5.312,0,0,1,.146,7.171,7.905,7.905,0,0,1,0,6.356C.774,7.828,1.962,8.852,3.567,8.209Z",
    transform: "translate(0.061 2.844)",
    fill: "#262743"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_889-2",
    "data-name": "Ellipse 889",
    cx: 2.593,
    cy: 0.886,
    rx: 2.593,
    ry: 0.886,
    transform: "translate(6.283 0.737)",
    fill: "#fcfffd",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_890-2",
    "data-name": "Ellipse 890",
    cx: 1.124,
    cy: 0.886,
    rx: 1.124,
    ry: 0.886,
    transform: "translate(1.458 5.458)",
    fill: "#fcfffd",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16185-2",
    "data-name": "Path 16185",
    d: "M10.71,0s1.24,7.364.224,9.777S8.584,12,8.584,12v2.54s2.937.64,3.212,2.438c.342,2.237,1.06,6.272-3.71,7.6S1.439,22.012.277,20.058s1.7-4.819,1.7-4.819a21.958,21.958,0,0,0,.572-6.287A2.2,2.2,0,0,1,.277,6.62C.272,4.357,1.922,4.929,2,5.526a4,4,0,0,0,.336-1.643,5.609,5.609,0,0,1,1-3.247A6.81,6.81,0,0,0,10.71,0Z",
    transform: "translate(3.338 6.513)",
    fill: "#ffcbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16186-2",
    "data-name": "Path 16186",
    d: "M.842,6.822C.518,6.928.373,5.824,0,5.5a4.05,4.05,0,0,0,.325-1.62,5.608,5.608,0,0,1,1-3.247A6.81,6.81,0,0,0,8.7,0s.08.478.183,1.227c-3.031,1.867-6.457.7-7.056.964S1.212,6.822.842,6.822Z",
    transform: "translate(5.346 6.513)",
    fill: "#ffad81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16187-2",
    "data-name": "Path 16187",
    d: "M0,4.076A18.356,18.356,0,0,0,.245,0a7.376,7.376,0,0,0,6,2.706V5.237C4.152,5.963,1.914,5.106,0,4.076Z",
    transform: "translate(5.675 15.807)",
    fill: "#ffad81"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5195-2",
    "data-name": "Group 5195",
    transform: "translate(4.517 8.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5191-2",
    "data-name": "Group 5191",
    transform: "translate(4.286 1.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5190-2",
    "data-name": "Group 5190",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_891-2",
    "data-name": "Ellipse 891",
    cx: 0.668,
    cy: 0.527,
    rx: 0.668,
    ry: 0.527,
    transform: "matrix(-0.107, -0.994, 0.994, -0.107, 0.143, 1.947)",
    fill: "#262743"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_892-2",
    "data-name": "Ellipse 892",
    cx: 0.668,
    cy: 0.527,
    rx: 0.668,
    ry: 0.527,
    transform: "matrix(-0.107, -0.994, 0.994, -0.107, 4.257, 1.441)",
    fill: "#262743"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5192-2",
    "data-name": "Group 5192",
    transform: "translate(7.012 2.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16188-2",
    "data-name": "Path 16188",
    d: "M.328,2.417A.809.809,0,0,1,.1,2.372a.083.083,0,0,1,.055-.157.593.593,0,0,0,.581-.093.312.312,0,0,0,.108-.306A2.22,2.22,0,0,0,.527,1.28C.245.875-.076.417.016.062A.084.084,0,0,1,.117,0a.082.082,0,0,1,.06.1C.1.384.414.828.663,1.185a2.17,2.17,0,0,1,.344.595.472.472,0,0,1-.16.467A.725.725,0,0,1,.328,2.417Z",
    fill: "#ff6162"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5193-2",
    "data-name": "Group 5193",
    transform: "translate(3.019 0.572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16189-2",
    "data-name": "Path 16189",
    d: "M2.607.209A.244.244,0,0,0,2.461.09,2.406,2.406,0,0,0,.08.8a.246.246,0,0,0,.331.364A1.93,1.93,0,0,1,2.318.561.245.245,0,0,0,2.625.4.244.244,0,0,0,2.607.209Z",
    fill: "#262743"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16190-2",
    "data-name": "Path 16190",
    d: "M1.776.562C1.97.558,2,.075,1.8.036A2.3,2.3,0,0,0,.121.391a.264.264,0,0,0,.088.48.241.241,0,0,0,.2-.037A1.77,1.77,0,0,1,1.776.562Z",
    transform: "translate(7.966)",
    fill: "#262743"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5194-2",
    "data-name": "Group 5194",
    transform: "translate(5.557 5.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16191-2",
    "data-name": "Path 16191",
    d: "M2.053,1.367A3.259,3.259,0,0,1,.051.6.1.1,0,0,1,.009.47.094.094,0,0,1,.134.427a3.42,3.42,0,0,0,3.384-.4.093.093,0,0,1,.133,0,.1.1,0,0,1,0,.132A2.475,2.475,0,0,1,2.053,1.367Z",
    fill: "#fcfffd"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_893-2",
    "data-name": "Ellipse 893",
    cx: 0.191,
    cy: 0.322,
    rx: 0.191,
    ry: 0.322,
    transform: "matrix(-0.107, -0.994, 0.994, -0.107, 7.105, 4.462)",
    fill: "#fcfffd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16192-2",
    "data-name": "Path 16192",
    d: "M1.924.146c.032.3-.373.586-.9.643S.032.651,0,.352,1.893-.153,1.924.146Z",
    transform: "translate(6.558 7.286)",
    fill: "#ffad81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16193-2",
    "data-name": "Path 16193",
    d: "M.184.014C.471-.075.832.267.99.777s.055,1-.232,1.086c-.143.045-.551-.355-.694-.818S.041.059.184.014Z",
    transform: "translate(0 3.942)",
    fill: "#ffad81"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_16228",
    "data-name": "Path 16228",
    d: "M134.757,436.379l2.985,1.322.748-5.384h-3.514Z",
    transform: "translate(-87.801 -313.393)",
    fill: "#ffcbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16229",
    "data-name": "Path 16229",
    d: "M66.463,348.985,64.4,351.261l2.65,3,2.363-2.6Z",
    transform: "translate(-52.35 -271.405)",
    fill: "#ffcbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16230",
    "data-name": "Path 16230",
    d: "M57.37,344.66c.168.938-1.656,2.811-2.593,2.856s-3.767.633-4.529.755-3.053,1.581-3.913,1.354a1.027,1.027,0,0,1-.779-1.347c.14-.342,7.7-7.836,7.7-7.836S57.126,343.3,57.37,344.66Z",
    transform: "translate(-42.827 -267.101)",
    fill: "#262743"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16231",
    "data-name": "Path 16231",
    d: "M131.82,438.856c.969-.539,4.156.6,4.559,1.616s1.455,2.645,1.877,3.438,3.884,2.767,3.959,3.8a1.2,1.2,0,0,1-1.19,1.366c-.429-.025-11.864-4.264-11.864-4.264S130.418,439.635,131.82,438.856Z",
    transform: "translate(-84.982 -316.617)",
    fill: "#262743"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5209",
    "data-name": "Group 5209",
    transform: "translate(13.727 46.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16232",
    "data-name": "Path 16232",
    d: "M111.173,287.31a145.313,145.313,0,0,1,.233,33.629c-2.1,17.209-6.476,38.964-6.555,39.279s-3.711.71-3.869-.632-.668-45.327-1.487-45.6-6.965,19.7-12.7,22.708-18.85-13.72-19-14.257,2.224-2.99,2.837-2.76,10.888,7.514,11.654,7.437,4.217-14.875,5.6-20.242,2.99-15.258,7.437-18.555Z",
    transform: "translate(-67.783 -287.31)",
    fill: "#2f3a79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16233",
    "data-name": "Path 16233",
    d: "M117.613,288.318c-2.723,2.019-4.382,6.511-5.576,10.923,6.828,3.262,15.311,2.926,22.42.24-.289-7.259-.986-12.17-.986-12.17Z",
    transform: "translate(-90.081 -287.31)",
    fill: "#2f3a79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16234",
    "data-name": "Path 16234",
    d: "M142.162,329.236c.155-1.407,4.769-5.381,5.73-4.78s-1.32,23.992-2.521,25.552S141.922,331.407,142.162,329.236Z",
    transform: "translate(-105.25 -305.995)",
    fill: "#2f3a79",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16235",
    "data-name": "Path 16235",
    d: "M111.425,324.231c1.051-.93,3.61,2.425,4.025,3.511s-8.776,18.25-9.994,17.93S109.87,325.607,111.425,324.231Z",
    transform: "translate(-86.679 -305.832)",
    fill: "#2f3a79",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16236",
    "data-name": "Path 16236",
    d: "M73.764,355.131c.143-.667,10.488,6.171,10.743,6.98C85.264,364.514,73.4,356.809,73.764,355.131Z",
    transform: "translate(-70.792 -321.459)",
    fill: "#2f3a79",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5210",
    "data-name": "Group 5210",
    transform: "translate(12.197 5.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16237",
    "data-name": "Path 16237",
    d: "M119.84,209.219s-2.143,10.532-2.48,10.725-5.422-.027-9.668-.539c-3.249-.392-7.131-.27-7.5-.026-.841.563-4.488,1.671-6.368.725s-13.856-5.824-15.16-6.762-10.54-8.635-10.9-8.9-3.454,2.775-3.024,3.633,8.284,12.97,9.485,13.682,13.584,9.873,14.185,10.645c.433.556,1.3,10.886,1.278,17.163-.01,2.435-1.419,4.26-1.156,4.667.944,1.458,4.136,3.26,11.428,2.917s9.8-1.2,11.085-3.775c.312-.624-.6-2.382-.665-4.7-.189-7.247-.718-19.957-.523-20.477.257-.686,10.967.426,12.11-1.031.733-.935,2.96-15.941,2.96-16.628S120.213,208.457,119.84,209.219Z",
    transform: "translate(-64.699 -204.43)",
    fill: "#ca353b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16238",
    "data-name": "Path 16238",
    d: "M122.619,210.177c1.352,2.638-.673,8.864-1.39,12.616-.5,0-1.825-1.612-2.293-1.144s1.545,3.624,1.137,4.147c-2.338,3-11.128-2.229-11.973-1.806-.992.5,2.208,8.763-.266,11.206s-12.152,3.077-14.884,0-.39-7.771-2.633-9.421c-.707-.52-1.11,2.812-2.742,2.169-4.074-1.607-11.2-6.843-12.105-8.22s-6.747-8.014-8.909-13.684c-.963.9-2.093,2.309-1.822,2.85.429.858,8.284,12.97,9.485,13.682s13.584,9.873,14.185,10.645c.433.556,1.3,10.886,1.278,17.163-.01,2.435-1.419,4.26-1.156,4.667.944,1.458,4.136,3.26,11.428,2.917s9.8-1.2,11.085-3.775c.312-.624-.6-2.382-.665-4.7-.189-7.247-.718-19.957-.523-20.477.257-.686,10.967.426,12.11-1.031.733-.935,2.96-15.941,2.96-16.628C124.925,210.987,123.671,210.512,122.619,210.177Z",
    transform: "translate(-64.699 -205.242)",
    fill: "#714f83",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16239",
    "data-name": "Path 16239",
    d: "M119.531,239.033c.662-1.3,4.073,3.712,6.927,3.846s6.321-5.455,6.8-5.136,2.15,6.921.8,7.886-10.325,2.626-11.775.908S118.814,240.44,119.531,239.033Z",
    transform: "translate(-92.251 -221.208)",
    fill: "#fff",
    opacity: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5234",
    "data-name": "Group 5234",
    transform: "translate(59.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5228",
    "data-name": "Group 5228",
    transform: "translate(0 20.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5212",
    "data-name": "Group 5212",
    transform: "translate(19.576 122.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16240",
    "data-name": "Path 16240",
    d: "M200.093,331.3c.643,1.378,4.17.188,5.867-2.667s1.872-3.616,1.965-4.259-.493-1.743-.763-1.637c-.66.26-7.329,5.367-7.472,7.6A4.707,4.707,0,0,0,200.093,331.3Z",
    transform: "translate(-199.689 -322.726)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_900",
    "data-name": "Ellipse 900",
    cx: 32.54,
    cy: 5.849,
    rx: 32.54,
    ry: 5.849,
    transform: "translate(7.526 132.505)",
    fill: "#404c73",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5221",
    "data-name": "Group 5221",
    transform: "translate(34.704 7.21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5214",
    "data-name": "Group 5214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16241",
    "data-name": "Path 16241",
    d: "M232.15,104.452c-1.123-1.191-1.5-3.528-1.855-4.765a2.763,2.763,0,0,1,1.5-3.329,2.457,2.457,0,0,1,2.917-3.313c.823-2.814,3.829-2.777,4.968-.729a2.12,2.12,0,0,1,3.78,1.778c2.273.672,1.976,3.343-.241,3.765-2.123.4-8.945,6.566-9.65,7.476C233.567,105.335,233.273,105.642,232.15,104.452Z",
    transform: "translate(-230.181 -90.848)",
    fill: "#262743"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5213",
    "data-name": "Group 5213",
    transform: "translate(0.403 0.687)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_901",
    "data-name": "Ellipse 901",
    cx: 1.266,
    cy: 0.962,
    rx: 1.266,
    ry: 0.962,
    transform: "translate(5.474)",
    fill: "#404c73"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_902",
    "data-name": "Ellipse 902",
    cx: 1.049,
    cy: 0.797,
    rx: 1.049,
    ry: 0.797,
    transform: "translate(9.978 0.699)",
    fill: "#404c73"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_903",
    "data-name": "Ellipse 903",
    cx: 1.049,
    cy: 0.797,
    rx: 1.049,
    ry: 0.797,
    transform: "translate(11.683 3.083)",
    fill: "#404c73"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_904",
    "data-name": "Ellipse 904",
    cx: 1.049,
    cy: 0.797,
    rx: 1.049,
    ry: 0.797,
    transform: "translate(1.559 3.089) rotate(-37.344)",
    fill: "#404c73"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_905",
    "data-name": "Ellipse 905",
    cx: 1.049,
    cy: 0.797,
    rx: 1.049,
    ry: 0.797,
    transform: "translate(0 6.752) rotate(-37.344)",
    fill: "#404c73"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_16242",
    "data-name": "Path 16242",
    d: "M244.96,103.605s1.461,7.868.445,10.281-2.35,2.223-2.35,2.223v2.54s2.937.64,3.212,2.438c.342,2.237,1.06,6.272-3.71,7.6s-6.647-2.563-7.808-4.517,1.7-4.82,1.7-4.82a21.959,21.959,0,0,0,.572-6.287,2.2,2.2,0,0,1-2.274-2.332c0-1.757.99-1.8,1.47-1.459.191.137.486.782.633.6.286-.359.061-1.447-.046-1.876-.28-1.125-.25-2.873.56-3.435,1.958-1.359,3.42.316,5.289.124C244.71,104.469,244.96,103.605,244.96,103.605Z",
    transform: "translate(-232.342 -97.276)",
    fill: "#ffcbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16243",
    "data-name": "Path 16243",
    d: "M239.734,110.759c.451-.116-.926-4.534,1.006-5.1,2.068-.414,3.645.85,6.655-.7-.128-.824-.226-1.355-.226-1.355s-.249.864-2.307,1.076c-1.869.193-3.331-1.482-5.289-.124-.81.562-.834,2.309-.56,3.435.285,1.175.2,1.6.046,1.876C239.12,110.18,239.283,110.875,239.734,110.759Z",
    transform: "translate(-234.552 -97.276)",
    fill: "#ffad81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16244",
    "data-name": "Path 16244",
    d: "M245.471,127.572v-1.861a8.121,8.121,0,0,1-6.033-3.048,19.819,19.819,0,0,1-.171,4.137A7.126,7.126,0,0,0,245.471,127.572Z",
    transform: "translate(-234.759 -106.878)",
    fill: "#ffad81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16245",
    "data-name": "Path 16245",
    d: "M243.105,123.289a4.417,4.417,0,0,0,4.3,2.481s1.334.191,2.35-2.223a3.776,3.776,0,0,0,.215-.769c-.633,1.385-1.594,2.311-2.368,1.271C247.38,125.264,244.655,124.548,243.105,123.289Z",
    transform: "translate(-236.693 -106.936)",
    fill: "#262743"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5220",
    "data-name": "Group 5220",
    transform: "translate(2.887 8.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5216",
    "data-name": "Group 5216",
    transform: "translate(4.699 1.529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5215",
    "data-name": "Group 5215",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_906",
    "data-name": "Ellipse 906",
    cx: 0.54,
    cy: 0.685,
    rx: 0.54,
    ry: 0.685,
    transform: "matrix(0.992, -0.125, 0.125, 0.992, 0, 0.734)",
    fill: "#262743"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_907",
    "data-name": "Ellipse 907",
    cx: 0.54,
    cy: 0.685,
    rx: 0.54,
    ry: 0.685,
    transform: "matrix(0.992, -0.125, 0.125, 0.992, 4.207, 0.136)",
    fill: "#262743"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5217",
    "data-name": "Group 5217",
    transform: "translate(7.494 2.551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16246",
    "data-name": "Path 16246",
    d: "M251.484,115.252a.846.846,0,0,1-.233-.042.085.085,0,1,1,.054-.161.609.609,0,0,0,.593-.106.319.319,0,0,0,.1-.316,2.275,2.275,0,0,0-.336-.544c-.3-.409-.635-.873-.548-1.238a.085.085,0,1,1,.165.04c-.069.289.258.738.519,1.1a2.24,2.24,0,0,1,.364.6.486.486,0,0,1-.154.482A.741.741,0,0,1,251.484,115.252Z",
    transform: "translate(-251.105 -112.779)",
    fill: "#ff6162"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5218",
    "data-name": "Group 5218",
    transform: "translate(3.301 0.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16247",
    "data-name": "Path 16247",
    d: "M245.536,109.283a.262.262,0,0,0-.139-.147,2.582,2.582,0,0,0-2.632.436.264.264,0,0,0-.065.368.262.262,0,0,0,.255.11.266.266,0,0,0,.113-.045,2.071,2.071,0,0,1,2.113-.387.259.259,0,0,0,.2.006.263.263,0,0,0,.147-.139A.259.259,0,0,0,245.536,109.283Z",
    transform: "translate(-242.653 -108.941)",
    fill: "#262743"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16248",
    "data-name": "Path 16248",
    d: "M254.835,108.2a.406.406,0,0,0-.046-.564,2.357,2.357,0,0,0-1.467.553.283.283,0,1,0,.366.433A1.81,1.81,0,0,1,254.835,108.2Z",
    transform: "translate(-244.677 -107.638)",
    fill: "#262743"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5219",
    "data-name": "Group 5219",
    transform: "translate(6.072 5.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16249",
    "data-name": "Path 16249",
    d: "M250.214,120.211c-.671.085-1.367-.545-1.922-1.123-.037-.038-.068-.08-.046-.128a.1.1,0,0,1,.128-.046,3.988,3.988,0,0,0,3.461-.475.1.1,0,0,1,.136,0c.039.037.026.088,0,.136C251.648,119.262,250.924,120.121,250.214,120.211Z",
    transform: "translate(-248.238 -118.41)",
    fill: "#fcfffd"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_908",
    "data-name": "Ellipse 908",
    cx: 0.329,
    cy: 0.195,
    rx: 0.329,
    ry: 0.195,
    transform: "matrix(0.992, -0.125, 0.125, 0.992, 7.587, 4.325)",
    fill: "#fcfffd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_909",
    "data-name": "Ellipse 909",
    cx: 0.492,
    cy: 0.83,
    rx: 0.492,
    ry: 0.83,
    transform: "translate(0 4.775) rotate(-21.506)",
    fill: "#ffad81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16250",
    "data-name": "Path 16250",
    d: "M252.254,123.054c.031.243-.385.5-.929.565s-1.009-.072-1.04-.316S252.224,122.811,252.254,123.054Z",
    transform: "translate(-243.198 -115.355)",
    fill: "#ffad81"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5222",
    "data-name": "Group 5222",
    transform: "translate(0 33.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16251",
    "data-name": "Path 16251",
    d: "M183.49,151.535l-4.1,3.685s-12.114-7.416-12.17-7.455c-.512-.349-.513-2.727-.846-3.153a3.665,3.665,0,0,0-2.208-.83c-.537.052-.962.352-.991.736-1.069-.875-1.943.192-1.5.893a5.12,5.12,0,0,0-.99,2.9c-.531.169-.473,1.064.013,1.42.645.472,3.379,1.481,4.322,1.307.038.046,13.973,12.307,15.164,12.241,1.623-.09,6.662-5.126,6.707-4.945S183.49,151.535,183.49,151.535Z",
    transform: "translate(-160.234 -143.778)",
    fill: "#ffcbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16252",
    "data-name": "Path 16252",
    d: "M185.386,156.62c-1.309,1.873-3.616,4.544-4.839,4.182s-14.525-9.745-15.085-10.563c-.529-.774-.646-1.764.143-3.172-1.291.672-.967,2.824-2.86,2.586-.186-.8.622-2.175.57-3.343-.568.944-1.051,3.963-1.458,4.183a1.29,1.29,0,0,1-1.392-.049.981.981,0,0,0,.354.551,10.5,10.5,0,0,0,4.168,1.333c.044,0,.124-.011.162-.018.01.012,2.557,2.235,2.557,2.235s11.738,10.054,12.607,10.006c1.623-.09,6.662-5.126,6.707-4.945C187.031,159.659,185.8,157.442,185.386,156.62Z",
    transform: "translate(-160.35 -145.053)",
    fill: "#ffad81"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5224",
    "data-name": "Group 5224",
    transform: "translate(51.181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5223",
    "data-name": "Group 5223"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16253",
    "data-name": "Path 16253",
    d: "M263.391,103.264,276.209,91.6s9.634-10.438,9.677-10.49c.4-.475-.251-2.764-.046-3.265a3.662,3.662,0,0,1,1.9-1.4.988.988,0,0,1,1.155.438c.79-1.133,1.922-.346,1.689.449a.8.8,0,0,1,1.071,1.137.8.8,0,0,1,.671,1.382c.557.018.745.895.375,1.37-.492.63-2.847,2.347-3.8,2.436-.024.055-9.871,14.614-10.758,15.412-1.209,1.087-9.572,9.508-9.416,9.609S263.391,103.264,263.391,103.264Z",
    transform: "translate(-263.391 -76.316)",
    fill: "#ffcbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16254",
    "data-name": "Path 16254",
    d: "M263.391,104.349c.678-.671,6.2-5.638,7.9-7.188.263.614,1.919,3.38,3.139,3.235s13.333-16.808,13.586-17.56c.3-.889.141-1.873-1-3.013,1.425.295,1.7,2.453,3.457,1.709-.04-.821-1.191-1.923-1.46-3.062.8.753,2.092,3.527,2.543,3.627a1.29,1.29,0,0,0,1.326-.426.983.983,0,0,1-.191.627,10.512,10.512,0,0,1-3.646,2.419c-.043.009-.122.023-.161.027-.006.015-1.85,2.847-1.85,2.847s-8.257,11.989-8.9,12.571c-1.209,1.087-9.566,9.512-9.41,9.613C268.764,109.8,264.036,105.005,263.391,104.349Z",
    transform: "translate(-263.391 -77.402)",
    fill: "#ffad81"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_16255",
    "data-name": "Path 16255",
    d: "M204.1,307.934l1.151,6.09,3.232-.412-.111-6.524Z",
    transform: "translate(-182.337 -192.593)",
    fill: "#ffcbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16256",
    "data-name": "Path 16256",
    d: "M258.375,335.371l.693,5.407h3.466V334.47Z",
    transform: "translate(-209.683 -206.389)",
    fill: "#ffcbae"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5225",
    "data-name": "Group 5225",
    transform: "translate(17.238 66.491)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16257",
    "data-name": "Path 16257",
    d: "M198.624,260.41l6.382-.473s-1.128-19.92-.117-23.458,12.161-10.435,12.161-10.435,6.433,23.17,6.578,24.977,1.445,23.488,1.445,23.488l6.938-.578s1.012-23.561,1.012-26.307-.723-37.292-.723-37.292H208.739s-12.957,17.558-13.68,22.039S198.624,260.41,198.624,260.41Z",
    transform: "translate(-194.978 -210.332)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16258",
    "data-name": "Path 16258",
    d: "M211.184,216.339c-1.529.214-8,9.3-12.675,18.4-.186.46.734.832,1.194,1.018,2.583-1.1,15.113-11.186,14.867-13.455S212.712,216.126,211.184,216.339Z",
    transform: "translate(-196.744 -213.355)",
    fill: "#333",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16259",
    "data-name": "Path 16259",
    d: "M249.636,228.513c-.447,1.535,3.813,21.282,5.119,21.282s2.325-25.743,1.221-26.26S250.083,226.978,249.636,228.513Z",
    transform: "translate(-222.501 -216.961)",
    fill: "#333",
    opacity: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5226",
    "data-name": "Group 5226",
    transform: "translate(21.475 18.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16260",
    "data-name": "Path 16260",
    d: "M213.02,144.464s.111,12.738-1.329,18.609c0,0,10.744,5.206,26.917,0a134.165,134.165,0,0,1-1.44-15.065c0-5.539.111-14.622.111-14.622s3.993-5.971,6.984-10.29l-4.879-8.651s-6.3,5.4-8.074,6.459-3.85,2.179-3.85,2.179l-1.353,7.2-5.252-5.477s-5.32,1.356-7.146,2.628a54.548,54.548,0,0,0-10.191,10.439l4.805,8.4Z",
    transform: "translate(-203.517 -114.445)",
    fill: "#2f3a79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16261",
    "data-name": "Path 16261",
    d: "M244.262,130.044l-1.02-1.808c-1.926,1.6-3.9,5.9-5.053,7.265s-2.345-1.706-3.027-.593,2.154,8.5-.326,12.466c-1.488,1.488-14.507,8.357-17.484,4.885-1.488-1.985-.916-10.57-2.668-10.893-1.051-.193-1.134,4.428-2.268,7.285a3.647,3.647,0,0,1-3.1,2.36c-1.057-.245-2.8-5.253-4.515-7.778-.422.513-.849,1.041-1.283,1.594l4.805,8.4,4.7-1.81s.111,12.738-1.329,18.609c0,0,10.744,5.206,26.917,0a134.18,134.18,0,0,1-1.44-15.065c0-5.538.111-14.621.111-14.621S241.271,134.365,244.262,130.044Z",
    transform: "translate(-203.517 -121.394)",
    fill: "#2f3a79",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16262",
    "data-name": "Path 16262",
    d: "M233.542,129.793c.952.387,6.484,5.945,7.458,5.737s2.046-9.186,2.755-9.4,1.814-1.525,2.229-1.525,1.866,1.8,2.281,1.525-.069-3.562.484-3.718,3.732-3.406,4.078-3.337-2.765,3.856-2.765,4.416-.207,4.363-.761,4.5a15.285,15.285,0,0,1-3.318-.689s-2.293,10.782-3.082,11.127-8.393,2.212-9.361,2-2.861-8.433-2.427-9.193S232.674,129.44,233.542,129.793Z",
    transform: "translate(-217.39 -116.779)",
    fill: "#2f3a79",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16263",
    "data-name": "Path 16263",
    d: "M199.8,326.263c.439,1.277,3.274.468,5.037-1.894a16.269,16.269,0,0,0,2.626-4.57,7.447,7.447,0,0,0-1.231-3.5c-.49-.463-3.309-.351-3.8.544s-.631,3.55-.966,4.691S199.215,324.569,199.8,326.263Z",
    transform: "translate(-180.113 -197.097)",
    fill: "#262743"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16264",
    "data-name": "Path 16264",
    d: "M258.3,343.9c.427-.718,3.234-.811,3.943-.387s3.149,2.716,4.1,3.14,4.993,1.342,4.338,2.988-12.214-.348-12.6-.735S257.628,345.028,258.3,343.9Z",
    transform: "translate(-209.39 -210.818)",
    fill: "#262743"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5227",
    "data-name": "Group 5227",
    transform: "translate(48.193 137.638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16265",
    "data-name": "Path 16265",
    d: "M257.492,353.814a1.51,1.51,0,0,0,.231,1.571,31.044,31.044,0,0,0,6.08,1.078c3.207.29,6.415-.022,6.832-.328a1.284,1.284,0,0,0,.165-1.206c-.157-.41-2.036.27-6.526.029C260.495,354.756,257.749,353.391,257.492,353.814Z",
    transform: "translate(-257.369 -353.733)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5233",
    "data-name": "Group 5233",
    transform: "translate(75.014)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5231",
    "data-name": "Group 5231",
    transform: "translate(0 16.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16266",
    "data-name": "Path 16266",
    d: "M346.41,75.879a3.68,3.68,0,0,0-3.027-2.8,3.387,3.387,0,0,0-3.562,1.3c.2-1.1.259-1.781.259-1.781l-20.656-4.2s-.188.744-.377,1.98a3.375,3.375,0,0,0-2.87-2.794,3.68,3.68,0,0,0-3.858,1.452A5.621,5.621,0,0,0,312.246,75c.687,1.218,2.182,3.377,3.628,5.465a57.837,57.837,0,0,1,3.714,5.707.944.944,0,0,1-.355,1.12c-.475.254-1.025-.44-1.182-.658a.744.744,0,1,0-1.208.87,2.965,2.965,0,0,0,1.768,1.292,1.962,1.962,0,0,0,1.324-.191,2.385,2.385,0,0,0,1.175-2.4,19.088,19.088,0,0,0,3.125,4.506l-.488,2.4-.026-.005a.539.539,0,0,0-.215,1.057l.026.005-.123.6a2.1,2.1,0,0,0-.631,3.1l-.15.737-2.405-.49a1.43,1.43,0,1,0-.57,2.8l7.56,1.539a1.43,1.43,0,1,0,.57-2.8l-2.405-.49.15-.737a2.1,2.1,0,0,0,.631-3.1l.123-.6.026.005a.539.539,0,1,0,.215-1.057l-.026-.005.453-2.228a16.714,16.714,0,0,0,4.715-2.685,2.367,2.367,0,0,0,.327,2.385,1.963,1.963,0,0,0,1.155.675,2.964,2.964,0,0,0,2.124-.531.745.745,0,0,0-.792-1.261c-.228.143-1,.579-1.343.165a.945.945,0,0,1,.093-1.171,57.944,57.944,0,0,1,5.588-3.889c2.125-1.391,4.324-2.829,5.418-3.7A5.62,5.62,0,0,0,346.41,75.879ZM317.1,79.613c-1.427-2.061-2.9-4.192-3.556-5.349a4.1,4.1,0,0,1-.019-4.354,2.217,2.217,0,0,1,2.358-.869,1.893,1.893,0,0,1,1.7,1.575,2.639,2.639,0,0,1-1.193,2.568.744.744,0,1,0,.739,1.292,3.961,3.961,0,0,0,1.673-2.008,28.6,28.6,0,0,0,.465,8.6,21.817,21.817,0,0,0,.989,3.228C319.584,83.218,318.517,81.663,317.1,79.613Zm26.212.651c-1.041.827-3.21,2.246-5.308,3.618-1.611,1.054-2.917,1.913-3.9,2.594a20.428,20.428,0,0,0,1.783-2.234,24.911,24.911,0,0,0,3.264-7.048,3.862,3.862,0,0,0,.763,1.918.744.744,0,0,0,1.171-.92,2.639,2.639,0,0,1-.139-2.828,1.892,1.892,0,0,1,2.166-.82,2.217,2.217,0,0,1,1.857,1.693A4.1,4.1,0,0,1,343.309,80.264Z",
    transform: "translate(-311.43 -67.493)",
    fill: "#ffc672"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16267",
    "data-name": "Path 16267",
    d: "M346.409,75.879a3.68,3.68,0,0,0-3.027-2.8,3.387,3.387,0,0,0-3.562,1.3c.2-1.1.259-1.781.259-1.781l-11.706-2.382c-2.332,8.6-1,16.67-2.209,16.716s-6.756-6.216-4.795-18.141l-1.946-.4s-.188.744-.377,1.98a3.375,3.375,0,0,0-2.87-2.794,3.68,3.68,0,0,0-3.858,1.452A5.621,5.621,0,0,0,312.245,75c.687,1.218,2.182,3.377,3.628,5.465a57.841,57.841,0,0,1,3.714,5.707.945.945,0,0,1-.355,1.12c-.475.254-1.025-.44-1.182-.658a.744.744,0,0,0-1.208.87,2.965,2.965,0,0,0,1.768,1.292,1.962,1.962,0,0,0,1.324-.191,2.385,2.385,0,0,0,1.175-2.4,19.087,19.087,0,0,0,3.125,4.506l-.488,2.4-.026-.005a.539.539,0,1,0-.215,1.057l.026.005-.123.6a2.1,2.1,0,0,0-.631,3.1l-.15.737-2.405-.49a1.43,1.43,0,0,0-.57,2.8l7.56,1.539a1.43,1.43,0,1,0,.57-2.8l-2.405-.49.15-.737a2.1,2.1,0,0,0,.631-3.1l.123-.6.026.005a.539.539,0,1,0,.215-1.057l-.026-.005.453-2.228a16.714,16.714,0,0,0,4.715-2.685,2.367,2.367,0,0,0,.327,2.385,1.962,1.962,0,0,0,1.154.675,2.964,2.964,0,0,0,2.124-.531.745.745,0,0,0-.792-1.261c-.228.143-1,.579-1.343.165a.945.945,0,0,1,.093-1.171,57.954,57.954,0,0,1,5.588-3.889c2.125-1.391,4.324-2.829,5.418-3.7A5.62,5.62,0,0,0,346.409,75.879ZM317.1,79.613c-1.427-2.061-2.9-4.192-3.556-5.349a4.1,4.1,0,0,1-.019-4.354,2.217,2.217,0,0,1,2.358-.869,1.893,1.893,0,0,1,1.7,1.575,2.639,2.639,0,0,1-1.193,2.568.744.744,0,1,0,.739,1.292,3.961,3.961,0,0,0,1.673-2.008,28.6,28.6,0,0,0,.465,8.6,21.828,21.828,0,0,0,.989,3.228C319.584,83.218,318.516,81.663,317.1,79.613Zm26.212.651c-1.041.827-3.21,2.246-5.308,3.618-1.611,1.054-2.917,1.913-3.9,2.594a20.431,20.431,0,0,0,1.783-2.234,24.909,24.909,0,0,0,3.264-7.048,3.862,3.862,0,0,0,.763,1.918.744.744,0,1,0,1.171-.92,2.64,2.64,0,0,1-.139-2.828,1.892,1.892,0,0,1,2.166-.82,2.217,2.217,0,0,1,1.857,1.693A4.1,4.1,0,0,1,343.309,80.264Z",
    transform: "translate(-311.429 -67.493)",
    fill: "#ffb800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16268",
    "data-name": "Path 16268",
    d: "M337.992,121.969l.123-.6.026.005a.533.533,0,0,0,.606-.349c-.136.28-1.079.074-1.986-.107s-1.775-.316-1.843-.548a.537.537,0,0,0,.421.433l.026.005-.123.6Z",
    transform: "translate(-323.264 -94.135)",
    fill: "#404c73",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16269",
    "data-name": "Path 16269",
    d: "M339.471,115.019a2.681,2.681,0,0,1-2.714-.73l-.473,2.324a15.437,15.437,0,0,0,2.754.536Z",
    transform: "translate(-323.952 -91.072)",
    fill: "#404c73",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16270",
    "data-name": "Path 16270",
    d: "M336.46,128.237l.15-.737a2.109,2.109,0,0,0,1.022-1.407,2.062,2.062,0,0,0,.034-.372,10.3,10.3,0,0,1-4.177-.531c0,.019-.014.036-.018.056a2.108,2.108,0,0,0,.39,1.694l-.15.737Z",
    transform: "translate(-322.514 -96.564)",
    fill: "#404c73",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5229",
    "data-name": "Group 5229",
    transform: "translate(2.826 31.242)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3239",
    "data-name": "Rectangle 3239",
    width: 17.617,
    height: 3.941,
    transform: "matrix(0.98, 0.199, -0.199, 0.98, 0.786, 0)",
    fill: "#003731"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3240",
    "data-name": "Rectangle 3240",
    width: 8.082,
    height: 2.786,
    transform: "matrix(0.98, 0.199, -0.199, 0.98, 5.343, 1.517)",
    fill: "#ffc672"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5230",
    "data-name": "Group 5230",
    transform: "translate(10.808 3.558)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16271",
    "data-name": "Path 16271",
    d: "M336.592,75.451c-.793-.654-2.384-1.083-3.051-.536s-.423,9.272,1.737,10.024c.424.147.145-2.278.407-4.686C335.973,77.595,336.992,75.781,336.592,75.451Z",
    transform: "translate(-333.214 -74.665)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5232",
    "data-name": "Group 5232",
    transform: "translate(1.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16272",
    "data-name": "Path 16272",
    d: "M319.133,52.1l-1.638-.187a.289.289,0,0,0-.251.1l-1.082,1.243a.289.289,0,0,1-.5-.132l-.328-1.615a.288.288,0,0,0-.17-.208l-1.517-.645a.289.289,0,0,1-.029-.517l1.435-.812a.287.287,0,0,0,.145-.226l.145-1.642a.289.289,0,0,1,.483-.188l1.215,1.113a.288.288,0,0,0,.26.068l1.607-.37a.289.289,0,0,1,.328.4l-.684,1.5a.289.289,0,0,0,.015.268l.848,1.414A.29.29,0,0,1,319.133,52.1Z",
    transform: "translate(-313.471 -40.908)",
    fill: "#ffb800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16273",
    "data-name": "Path 16273",
    d: "M335.326,42.3l-1.578-.477a.289.289,0,0,0-.264.051L332.2,42.9a.289.289,0,0,1-.469-.22l-.034-1.648a.288.288,0,0,0-.13-.235l-1.377-.906a.289.289,0,0,1,.064-.514l1.557-.542a.288.288,0,0,0,.184-.2l.436-1.59a.289.289,0,0,1,.509-.1l1,1.313a.289.289,0,0,0,.244.114l1.647-.076a.289.289,0,0,1,.251.453l-.941,1.353a.291.291,0,0,0-.033.267l.581,1.542A.29.29,0,0,1,335.326,42.3Z",
    transform: "translate(-321.828 -35.69)",
    fill: "#ffb800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16274",
    "data-name": "Path 16274",
    d: "M376.724,63.612l1.58.468a.288.288,0,0,1,.192.188l.51,1.567a.289.289,0,0,0,.513.074l.934-1.358a.291.291,0,0,1,.238-.126h1.648a.289.289,0,0,0,.229-.465l-1-1.308a.289.289,0,0,1-.046-.265l.509-1.568a.289.289,0,0,0-.371-.362l-1.554.55a.289.289,0,0,1-.266-.039L378.5,60a.289.289,0,0,0-.458.242l.043,1.648a.289.289,0,0,1-.119.241l-1.333.969A.29.29,0,0,0,376.724,63.612Z",
    transform: "translate(-345.237 -47.332)",
    fill: "#ffb800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16275",
    "data-name": "Path 16275",
    d: "M365.747,48.57l1.639.178a.289.289,0,0,1,.223.15l.782,1.451a.289.289,0,0,0,.518-.019l.676-1.5a.288.288,0,0,1,.212-.166l1.621-.3a.289.289,0,0,0,.142-.5l-1.221-1.107a.288.288,0,0,1-.092-.253l.22-1.634a.289.289,0,0,0-.43-.289l-1.43.819a.29.29,0,0,1-.269.01l-1.486-.714a.289.289,0,0,0-.408.32l.337,1.613a.288.288,0,0,1-.074.258l-1.138,1.192A.289.289,0,0,0,365.747,48.57Z",
    transform: "translate(-339.68 -39.572)",
    fill: "#ffb800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16276",
    "data-name": "Path 16276",
    d: "M353.731,40.57l-1.317-.992a.289.289,0,0,0-.265-.043l-1.563.522a.289.289,0,0,1-.365-.368l.536-1.559a.289.289,0,0,0-.041-.266l-.98-1.325a.289.289,0,0,1,.237-.461l1.648.028a.289.289,0,0,0,.24-.121l.958-1.342a.289.289,0,0,1,.512.083l.482,1.576a.29.29,0,0,0,.19.191l1.572.5a.289.289,0,0,1,.079.513l-1.35.946a.288.288,0,0,0-.123.239l.014,1.648A.29.29,0,0,1,353.731,40.57Z",
    transform: "translate(-331.715 -34.523)",
    fill: "#ffb800"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_16277",
    "data-name": "Path 16277",
    d: "M345.71,225.227c.34-.3,3.323,1.483,6.538,1.435,3.821-.057,7.969-1.885,8.4-1.435.792.829-1.132,3.205-2.49,3.658s-12,2.037-12.448,1.584S344.352,226.435,345.71,225.227Z",
    transform: "translate(-193.73 -130.575)",
    fill: "#fcfffd",
    opacity: 0.15
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummeryerrors);
export default __webpack_public_path__ + "static/media/summeryerrors.a6580e8cb0f930d0c8cf1d82665b415f.svg";
export { ForwardRef as ReactComponent };